<template>
    <div>
        <v-card solo flat>
            <v-card-title>
                Tags Manager
                <v-spacer />
                <v-btn color="primary" @click="openDialog">Add Tag</v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="tags"
                    class="elevation-1"
                    :loading="loading"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-btn icon @click="editTag(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteTag(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" max-width="400px">
            <v-card :loading="loading">
                <v-card-title>{{
                    editMode ? 'Edit Tag' : 'Add Tag'
                }}</v-card-title>
                <v-card-text>
                    <v-text-field v-model="tagName" label="Tag Name" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="closeDialog" color="red">Cancel</v-btn>
                    <v-btn color="primary" @click="saveTag" :loading="loading"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'

export default {
    name: 'TagsManager',
    data() {
        return {
            tags: [],
            dialog: false,
            tagName: '',
            editMode: false,
            editTagId: null,
            headers: [
                { text: 'Name', value: 'name' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '100px',
                    align: 'center',
                },
            ],
            loading: false,
        }
    },
    async mounted() {
        try {
            this.loading = true
            const tags = await API.getToolTags()
            this.tags = tags.map(tag => ({
                id: tag,
                name: tag,
            }))
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        openDialog() {
            this.dialog = true
            this.editMode = false
            this.tagName = ''
            this.editTagId = null
        },
        closeDialog() {
            this.dialog = false
        },
        async saveTag() {
            try {
                this.loading = true
                if (this.tagName.trim() === '') return
                if (this.editMode) {
                    const tag = this.tags.find(t => t.id === this.editTagId)
                    await API.updateToolTag({
                        id: tag.name,
                        newTag: this.tagName,
                    })
                    if (tag) tag.name = this.tagName
                } else {
                    await API.createToolTag(this.tagName)
                    this.tags.push({ id: Date.now(), name: this.tagName })
                }
                this.closeDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        editTag(tag) {
            this.editMode = true
            this.dialog = true
            this.tagName = tag.name
            this.editTagId = tag.id
        },
        async deleteTag(tag) {
            try {
                this.loading = true
                const tagToDelete = this.tags.find(t => t.id == tag.id)
                await API.deleteToolTag({ id: tagToDelete.name })
                this.tags = this.tags.filter(t => t.id !== tag.id)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
